// noinspection JSCheckFunctionSignatures

import {FormStorage} from "../app/FormStorage";
import {confirmAlert} from "../extensions/Swal";

require('jquery');
require('../components/image-editing');
const ImageEditor = require('tui-image-editor');

export class ImageUpload
{
	element;
	input;
	key;
	imagePreview;
	dataUrlInput;
	defaultImagePreviewSrc;
	store;
	buttons;

	constructor(element)
	{
		let self = $(element);
		self.data('ImageUpload', this);

		this.element = element;
		this.input = element.querySelector('input[type="file"]');
		this.key = this.element.dataset.key || this.element.id || null;
		this.imagePreview = element.querySelector('.image-preview');
		this.defaultImagePreviewSrc = this.imagePreview.src;
		this.dataUrlInput = self.find('.edited-image-input').get(0);
		this.store = ('store' in this.element.dataset) || false;

		ImageUpload[this.key] = ImageUpload[this.key] || this;

		self.find('.edit-image-upload')
			.on('click', () =>
			{
				this.editImage();
				return false;
			});

		self.find('.delete-image-upload')
			.on('click', () =>
			{
				confirmAlert('Clear Image', 'Are you sure you wish to clear this image upload?',
					'Clear', 'Cancel', { icon: 'warning' })
					.then((result) =>
					{
						if (result)
							this.reset();
					});
				return false;
			});

		this.buttons = self.find('.edit-image-upload,.delete-image-upload')
			.attr('disabled', 'disabled');

		this.input.addEventListener('change', () =>
		{
			this.processImageFile();
			this.update();
		});

		this.restoreIfEnabled();
	}

	static enumerate()
	{
		$('.x-image-upload').each((i, elem) =>
		{
			let self = $(elem);
			if (self.data('ImageUpload'))
				return;

			(new ImageUpload(elem));
		});
	}

	reset()
	{
		this.dataUrlInput.value = '';
		this.input.value = '';
		this.update();
		this.storeIfEnabled();
	}

	processImageFile()
	{
		this.dataUrlInput.value = '';
		let nameElement = $(this.element).find('.image-upload-name');
		if (this.input.files.length > 0)
		{
			let file = this.input.files[0];
			let name = file.name;
			nameElement.text(name.length > 60 ? (name.substr(0, 60) + '...') : name);
			this.resizeImageIfNecessary(file);
		}
		else
			nameElement.text('No image selected');
	}

	resizeImageIfNecessary(file)
	{
		let editor = new ImageEditor(document.getElementById('tui-image-editor'),
		{
			usageStatistics: false,
		});

		editor.loadImageFromFile(file).then(() =>
		{
			let size = editor.getCanvasSize();
			let w = size.width;
			let h = size.height;
			if (w * h > 0.65e6)
			{
				let aspect = h / w;
				w = Math.floor(Math.sqrt(0.6e6/aspect));
				h = w * aspect;
				// noinspection JSUnresolvedFunction
				editor.resize({ width: w, height: h })
					.then(() =>
					{
						this.setImageFromDataUrl(editor.toDataURL({
							format: 'jpeg',
							quality: 0.9
						}));
					});
			}
			else if (this.store)
			{
				this.setImageFromDataUrl(editor.toDataURL({
					format: 'jpeg',
					quality: 0.9
				}));
			}
		});
	}

	setImageFromDataUrl(dataUrl)
	{
		this.dataUrlInput.value = dataUrl;
		this.imagePreview.src = this.dataUrlInput.value;
		this.input.value = '';
		this.storeIfEnabled();
	}

	update()
	{
		if (this.dataUrlInput.value)
		{
			this.buttons.removeAttr('disabled');
			this.imagePreview.src = this.dataUrlInput.value;
		}
		else if (this.input.files.length > 0)
		{
			this.buttons.removeAttr('disabled');
			this.imagePreview.src = this.getFileObjectUrl();
		}
		else
		{
			this.buttons.attr('disabled', 'disabled');
			this.dataUrlInput.value = '';
			this.imagePreview.src = this.defaultImagePreviewSrc;
		}
	}

	getFileObjectUrl()
	{
		return this.input.files.length ?
			URL.createObjectURL(this.input.files[0]) : null;
	}

	getDataUri()
	{
		return this.dataUrlInput.value || null;
	}

	getImageUrl()
	{
		return this.getDataUri() || this.getFileObjectUrl();
	}

	editImage()
	{
		let url = this.getImageUrl();
		showImageEditor(url, (editor) =>
		{
			if (editor)
			{
				this.setImageFromDataUrl(editor.toDataURL({
					format: 'jpeg',
					quality: 0.9
				}));
			}
			else
				console.log('Image editing cancelled.');
		});
	}

	enableStorage()
	{
		this.store = true;
		this.storeIfEnabled();
	}

	storeIfEnabled()
	{
		if (!this.store)
			return;

		if (this.input.files.length > 0)
			this.processImageFile();

		FormStorage.store(this.dataUrlInput);
	}

	restoreIfEnabled()
	{
		if (!this.store)
			return;

		FormStorage.restore(this.dataUrlInput);
		if (this.dataUrlInput.value)
			this.update();
	}
}

window.ImageUpload = ImageUpload;

$(ImageUpload.enumerate);
